module.exports = __webpack_public_path__ + "img/10 to end of month-incomes-and-expenses.75a2c1de.svg";